import { Col, Label, Modal, ModalBody, ModalHeader, Row, Form } from "reactstrap"

import PropTypes from 'prop-types'
import React, { useState, useEffect } from "react"
import Select from 'react-select';
import ReactTextareaAutosize from "react-textarea-autosize";
import { useFormik } from "formik";
import * as Yup from 'yup';
import * as CONSTANTS from 'common/utils/data_validations';

import { useDispatch, useSelector } from "react-redux";
import { getPrimaryButtonClass } from "helpers/sf_utils";
import { MIN_CAR_FIFTY } from "helpers/sf_constants";
import { phoneNumberFormatter } from 'pages/Admin/Users/UserComponents/UserList/Formatters';
import { getLeadRefundReasons } from "store/leads/lead_refund_reasons_actions";
import useSingleActionDispatcher from "hooks/useSingleActionDispatcher";


const RefundModal = ({ title, show, onRefundClick, onCloseClick, refund_requested_for, phone_of_refund_requested_for }) => {
  const { lead_refund_reasons } = useSelector(state => ({
    lead_refund_reasons: state.Leads.lead_refund_reasons,
  }));

  const [optionsRequestRefundReasons, setOptionsRequestRefundReasons] = useState([]);
  const dispatch = useDispatch();

  useSingleActionDispatcher(getLeadRefundReasons());

  useEffect(() => {
    if (lead_refund_reasons) {
      const options = lead_refund_reasons.filter(item => !item?.discarded_at).map((item) => {
        return {
          label: item.reason,
          value: item.id,
        }
      });
      setOptionsRequestRefundReasons(options);
    }

  }, [lead_refund_reasons]);


  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      refund_requested_for: refund_requested_for || '',
      phone_of_refund_requested_for: phone_of_refund_requested_for || '',
      comments: '',
      reason: null,
    },
    validationSchema: Yup.object({
      comments: Yup.string().min(MIN_CAR_FIFTY)
        .required(CONSTANTS.STR_REQUIRED_FIELD),
      reason: Yup.object().required(CONSTANTS.STR_REQUIRED_FIELD)
        .shape({
          label: Yup.string().required(),
          value: Yup.string().required(),
        })
    }),
    onSubmit: (values) => {
      onRefundClick({
        ...values,
        lead_refund_reason_id: values.reason.value
      });
    },

  });

  return (
    <Modal isOpen={show?.active} toggle={onCloseClick} centered={true} size='md'>
      <ModalHeader>
        <div className="d-flex justify-content-center">
          <span className="modal-title font-weight-semibold text-black">
            {title}
          </span>
        </div>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={onCloseClick}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </ModalHeader>
      <ModalBody>
        <Form
          onSubmit={e => {
            e.preventDefault();
            validation.handleSubmit()
            return false
          }}
          className='sf-box-w'
        >
          <Row>
            <Col className="mx-2">
              <div className="d-flex flex-column">
                <Label className="font-weight-semibold mb-0">Name</Label>
                <div>{validation.values.refund_requested_for}</div>
              </div>
              <div className="mt-3 d-flex flex-column">
                <Label className="font-weight-semibold mb-0">Phone</Label>
                <div>{phoneNumberFormatter(validation.values.phone_of_refund_requested_for)}</div>
              </div>
              <div className="my-2">
                <Label className="font-weight-semibold">Reason</Label>
                <Select
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  options={optionsRequestRefundReasons}
                  placeholder='Select Reason...'
                  classNamePrefix="select2-selection"
                  onChange={(selectedOption) => {
                    const event = {
                      target: {
                        name: 'reason',
                        value: selectedOption,
                      },
                    };
                    validation.handleChange(event);
                  }}
                  onBlur={() => {
                    validation.handleBlur({
                      target: { name: 'reason' },
                    });
                  }}
                  value={validation.values.reason || null}
                  invalid={
                    !!(validation.touched.reason
                      && validation.errors.reason)
                  }
                />
                {validation.touched.reason
                  && validation.errors.reason ? (
                  <span className="text-danger">
                    {CONSTANTS.STR_REQUIRED_FIELD}
                  </span>
                ) : null}
              </div>
              <div className="mt-3 d-flex flex-column">
                <Label className="font-weight-semibold mb-0">Comment</Label>
                <span className="mb-1">Explain reason for refund request. Minimum 50 characters</span>
                <ReactTextareaAutosize
                  type='text'
                  className="form-control"
                  name="comments"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.comments || ''}
                  invalid={
                    !!(validation.touched.comments
                      && validation.errors.comments)
                  }
                />
                {validation.touched.comments
                  && validation.errors.comments ? (
                  <span className="text-danger" type="invalid">
                    {validation.errors.comments}
                  </span>
                ) : null}
              </div>
            </Col>
          </Row>
          <Row>
            <Col md="12" lg="12">
              <div className="text-end mt-3">
                <button
                  type="submit"
                  className={`btn ${getPrimaryButtonClass()} ms-2`}
                  name="submit"
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-light ms-2"
                  onClick={onCloseClick}
                >
                  Cancel
                </button>
              </div>
            </Col>
          </Row>
        </Form>
      </ModalBody>
    </Modal>
  )
}

RefundModal.propTypes = {
  onCloseClick: PropTypes.func,
  onRefundClick: PropTypes.func,
  show: PropTypes.any,
  title: PropTypes.any,
  refund_requested_for: PropTypes.string,
  phone_of_refund_requested_for: PropTypes.number
}

export default RefundModal;

